import { Shadow, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Container, Skeleton } from 'native-base';
import React from 'react';

export const LoadingItemTablet: React.FC = () => {
  return (
    <Shadow level={2} borderRadius={BoxRadius.sm} testId="customer-table-list">
      <VStack
        p={Spacing['inline.xxs']}
        borderRadius={BoxRadius.sm}
        space={Spacing['inline.xxxs']}
        flex={1}>
        <HStack alignItems={'center'} justifyContent={'space-between'}>
          <Skeleton
            w={'30%'}
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <HStack alignItems={'center'} space={Spacing['inline.nano']}>
            <Skeleton
              w={'24px'}
              h={'24px'}
              borderRadius={'full'}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w={'24px'}
              h={'24px'}
              borderRadius={'full'}
              endColor={Color['brand.primary.lightest']}
            />
          </HStack>
        </HStack>
        <HStack alignItems={'center'} space={Spacing['inline.nano']}>
          <HStack
            flex={1}
            alignItems={'center'}
            space={Spacing['inline.nano']}
            justifyContent={'space-between'}>
            <VStack space={Spacing['inline.quarck']} flex={1} maxW={'140px'}>
              <Skeleton
                w={'40%'}
                h={Typography['fontsize.xs']}
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />

              <Skeleton
                w={'full'}
                h={Typography['fontsize.md']}
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </VStack>
            <VStack space={Spacing['inline.quarck']} flex={1} maxW={'140px'}>
              <Skeleton
                w={'40%'}
                h={Typography['fontsize.xs']}
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />

              <Skeleton
                w={'full'}
                h={Typography['fontsize.md']}
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </VStack>
            <VStack space={Spacing['inline.quarck']} flex={1} maxW={'140px'}>
              <Skeleton
                w={'35%'}
                h={Typography['fontsize.xs']}
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />

              <Skeleton
                w={'full'}
                h={Typography['fontsize.md']}
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </VStack>
            <VStack space={Spacing['inline.quarck']} flex={1} maxW={'140px'}>
              <Skeleton
                w={'80%'}
                h={Typography['fontsize.xs']}
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
              <Skeleton
                w={'full'}
                h={Typography['fontsize.md']}
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </VStack>
            <Container />
          </HStack>
          <Skeleton
            w={'147px'}
            h={'38px'}
            borderRadius={'full'}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </VStack>
    </Shadow>
  );
};
